class FortuneTailHelpCenter {
  constructor(element) {
    this.element = element;
    this.search = element.querySelector('[data-help-search]');
    this.items = Array.from(element.querySelectorAll('[data-help-item]'));
    this.categories = Array.from(element.querySelectorAll('[data-help-category]'));
    this.empty = element.querySelector('[data-help-empty]');
    this.bindEvents();
  }

  bindEvents() {
    this.items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        this.items.forEach((otherItem) => {
          if (otherItem !== item) otherItem.open = false;
        });
      });
    });

    if (this.search) {
      this.search.addEventListener('input', () => this.filter());
    }
  }

  filter() {
    const query = this.search.value.trim().toLowerCase();
    let visibleCount = 0;

    this.items.forEach((item) => {
      const matches = item.textContent.toLowerCase().includes(query);
      item.hidden = !matches;
      if (matches) visibleCount += 1;
      if (!matches) item.open = false;
    });

    this.categories.forEach((category) => {
      category.hidden = !category.querySelector('[data-help-item]:not([hidden])');
    });

    if (this.empty) this.empty.hidden = visibleCount > 0;
  }
}

const initializeHelpCenters = (container = document) => {
  container.querySelectorAll('[data-help-center]').forEach((element) => {
    if (element.dataset.helpCenterReady === 'true') return;
    element.dataset.helpCenterReady = 'true';
    new FortuneTailHelpCenter(element);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeHelpCenters());
} else {
  initializeHelpCenters();
}

document.addEventListener('shopify:section:load', (event) => initializeHelpCenters(event.target));
